import { useRecoilValue } from "recoil";
import {
  backColorModal,
  foreColorCodePagination,
  foreColorPagination,
} from "../../../commons/colors";
import { Button, Modal } from "@mui/material";
import classes from "./SortDrawing.module.scss";
import { userState } from "../../../states/userState";
import { CustomIconButton } from "../atoms/buttons/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import SortingArea from "../molecules/sortDrawing/SortingArea";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useMergePdf } from "../../../hooks/useMergePdf";
const SortDrawing = (props) => {
  const { isShow, setIsShow, drawingList, setDrawingList } = props;
  const { mergePdf } = useMergePdf(setIsShow);
  const user = useRecoilValue(userState);
  const mode = user?.mode === "lite" ? "Lite" : "";

  const handleCombineClick = async () => {
    await mergePdf(drawingList);
  };

  return (
    <Modal
      open={isShow}
      onClose={() => setIsShow(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: "prmary.main",
        "&:focus-visible": {
          borderColor: "prmary.main",
          outlineColor: foreColorCodePagination(user?.mode ?? "dart"), // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <div
        className={classes.root}
        style={backColorModal(user?.mode ?? "lite")}
      >
        <div className={classes.buttons}>
          <Button
            variant="contained"
            size="small"
            onClick={handleCombineClick}
            disabled={!drawingList.length}
            sx={{
              backgroundColor: "#f25309",
              color: "#FFFFFF",
              fontSize: "11px",
              padding: "4px 4px",
              minWidth: "60px",
              height: "30px",
              "&:hover": {
                backgroundColor: "#f87234",
              },
              "&.Mui-disabled": {
                backgroundColor: "#37393F",
                color: "#707070",
              },
            }}
          >
            <PictureAsPdfIcon />
            結合
          </Button>
          <div className={classes.closeButton}>
            <div style={{ color: foreColorCodePagination(mode) }}>
              ファイル数 {drawingList.length}
            </div>
            <CustomIconButton
              icon={CancelIcon}
              disabled={false}
              onClick={() => setIsShow(false)}
              caption={"閉じる"}
            />
          </div>
        </div>
        <SortingArea
          drawingList={drawingList}
          setDrawingList={setDrawingList}
        />
      </div>
    </Modal>
  );
};

export default SortDrawing;
